
























































































































import Modal from "@/components/shared/modal/Modal.vue";
import { SearchExport } from "@/components/shared/SearchExport";
import { ShipmentDTO } from "@/model/data.model";
import { format, parse } from "date-fns";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    MbeModal: Modal
  }
})
export default class ShipmentElinkModal extends Vue {
  @Prop({})
  toggle: Function;
  @Prop({})
  shipments: ShipmentDTO[];
  elinkShipmentProducts: any[];
  tableWidth = "0px";

  created() {
    this.elinkShipmentProducts = this.prepElinkShipmentProducts();
    setTimeout(() => {
      this.setScrollbars();
      this.syncScrollbars();
    }, 500);
  }

  mounted() {
    this.setScrollbars();
    this.syncScrollbars();
  }

  setScrollbars() {
    const elinkModalTable: any = this.$refs.elinkModalTable;
    if (elinkModalTable) {
      this.tableWidth = elinkModalTable.bodyWidth;
    }
  }

  syncScrollbars() {
    const elinkModalTable: any = this.$refs.elinkModalTable;
    if (elinkModalTable) {
      const TopScrollbar: any = this.$refs.QDSTopScrollbar;

      const TableScroll: any = elinkModalTable.$refs.bodyWrapper;

      TableScroll.onscroll = () => {
        TopScrollbar.scrollLeft = TableScroll.scrollLeft;
      };

      TopScrollbar.onscroll = () => {
        TableScroll.scrollLeft = TopScrollbar.scrollLeft;
      };
    }
  }

  exportXLS() {
    const filename =
      this.$i18n.t("shipments") +
      "_" +
      this.$i18n.t("elink") +
      "_" +
      format(new Date(), "yyyy-MM-dd_HHmm") +
      ".xlsx";

    const exportData = this.elinkShipmentProducts.map(value => {
      const objToAdd: any = {};
      objToAdd[String(this.$i18n.t("shipmentDate"))] = value.shipmentDate;
      objToAdd[String(this.$i18n.t("mbeTracking"))] = value.mbeTracking;
      objToAdd[String(this.$i18n.t("shipmentTrackingNumber"))] =
        value.shipmentTrackingNumber;
      objToAdd[String(this.$i18n.t("elink_ordernumber"))] =
        value.orderNumberElink;
      objToAdd[String(this.$i18n.t("customer"))] = value.customerName;
      objToAdd[String(this.$i18n.t("addressTo.companyName"))] =
        value.addressToCompanyName;
      objToAdd[String(this.$i18n.t("sku"))] = value.sku;
      objToAdd[String(this.$i18n.t("description"))] = value.description;
      objToAdd[String(this.$i18n.t("quantity"))] = value.quantity;
      return objToAdd;
    });
    SearchExport.prototype.exportToXlsxV2(filename, exportData);
  }

  prepElinkShipmentProducts(): any[] {
    let result: any[] = [];
    this.shipments
      .filter(
        value =>
          value.source === "WEBSITE" && value.shipmentSource === "API_SOAP"
      )
      .forEach((shipRow: any) => {
        if (shipRow.productElink) {
          const rows = shipRow.productElink.map((eLinkProduct: any) => {
            return {
              shipmentDate: format(
                parse(shipRow.shipmentDate, "yyyy-MM-dd", new Date()),
                "dd/MM/yyyy"
              ),
              mbeTracking: shipRow.mbeTracking,
              shipmentTrackingNumber: shipRow.shipmentTrackingNumber,
              orderNumberElink: shipRow.orderNumberElink,
              customerName: shipRow.customerName,
              addressToCompanyName: shipRow.addressTo.companyName,
              sku: eLinkProduct.skucode,
              description: eLinkProduct.description,
              quantity: eLinkProduct.quantity
            } as any;
          });
          result = result.concat(rows);
        }
      });
    return result;
  }
}
